<div class="w-full h-[98%]" [attr.data-test-id]="'sp-custom-generic-table_container'">
  <span
    class="pl-4 pl-8 pl-12 pl-16 pl-20 pl-24 pl-28 w-[calc(80%-1rem)] w-[calc(80%-2rem)] w-[calc(80%-3rem)] w-[calc(80%-4rem)] w-[calc(80%-5rem)] w-[calc(80%-6rem)] w-[calc(80%-7rem)] hidden"
  ></span>
  <table class="table-auto w-full h-full rounded-xl">
    <tbody role="rowgroup">
      <cdk-virtual-scroll-viewport class="flex flex-row h-full scroller" #scroller [itemSize]="itemSize" (scrolledIndexChange)="setViewportData($event)">
        <tr class="table-row !bg-transparent h-[50px] text-left">
          <ng-container *ngFor="let col of tableCols | columnVisible; let i = index">
            <th [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x leading-5 flex" *ngIf="col['type'] !== tableColumnType.action">
              <div class="inline-block" *ngIf="expandActionColumn && col.columnDef === 'name'">
                <span class="pl-[20px] pr-[16px]"></span>
              </div>
              <span (click)="selectedFilter(i)" class="cursor-pointer pr-1" [ngClass]="col['type'] === tableColumnType.checkbox ? 'w-[8px]' : ''">{{
                col['type'] !== tableColumnType.checkbox ? col.header : ''
              }}</span>
              <ng-template [ngIf]="col.hasOwnProperty('filter') && col['filter'] === true">
                <mat-icon *ngIf="col.hasOwnProperty('filterSelected') && col['filterSelected'] === 1" class="material-icons-outlined !text-sm cursor-pointer"> arrow_upward </mat-icon>
                <mat-icon *ngIf="col.hasOwnProperty('filterSelected') && col['filterSelected'] === -1" class="material-icons-outlined !text-sm cursor-pointer"> arrow_downward </mat-icon>
              </ng-template>
            </th>
            <th
              class="!text-right table-cell-spacing-x w-[5%] sticky-action-column h-full"
              [ngClass]="{ 'sticky-action-header-color': col['type'] === tableColumnType.action }"
              *ngIf="col['type'] === tableColumnType.action && actionType === 'menu'"
            >
              <ng-container *ngTemplateOutlet="headerActionMenu"></ng-container>
            </th>
            <th class="!text-right table-cell-spacing-x w-[10%] sticky-action-column sticky-action-header-color" *ngIf="col['type'] === tableColumnType.action && actionType === 'action-button'"></th>
          </ng-container>
        </tr>
        <!-- using templateCacheSize: 0, because sp-avatar is keeps on changing view as scrolls through the large list -->
        <tr
          *cdkVirtualFor="let data of tableData; let i = index; templateCacheSize: 0"
          [ngClass]="{
            inserted: data['objectType'] && !data['root'] && (data['objectType'] === 'subProjects' || data['objectType'] === 'tasks' || data['objectType'] === 'subTasks'),
            rowClassName: data['rowClassName'],
            'h-[50px]': tableType && !['assets', 'collections'].includes(tableType),
            'h-[100px]': tableType && ['assets', 'collections'].includes(tableType),
            'h-auto': rowHeightAuto,
            'opacity-40': data['removedFlag'],
          }"
          class="table-row text-left cursor-pointer table-bg-color"
          [id]="'row-' + data['_id']"
        >
          <ng-container *ngFor="let col of tableCols | columnVisible">
            <ng-container [ngSwitch]="col['type']">
              <ng-container *ngSwitchCase="tableColumnType.action">
                <ng-container *ngIf="!configObject?.hideListViewMenu">
                  <td *ngIf="actionType === 'menu'" [ngClass]="col['class'] ? col['class'] : ''" class="!text-right table-cell-spacing-x sticky-action-column">
                    <ng-container *ngTemplateOutlet="rowActionMenu; context: { $implicit: data.categoryName === 'brandModell' ? data : data._id, type: data.type }"></ng-container>
                  </td>
                  <td *ngIf="actionType === 'action-button'" [ngClass]="col['class'] ? col['class'] : ''" class="!text-right whitespace-pre !static !grow-[6]">
                    <button
                      *ngIf="editFlag"
                      mat-icon-button
                      [attr.data-test-id]="'edit-button'"
                      (click)="editView($event, data)"
                      i18n-matTooltip
                      [matTooltip]="'Edit ' + (data['type'] || data['taskType'] || '')"
                    >
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </button>
                    <button
                      *ngIf="deleteFlag && data['taskType'] && data['status'] === 'Draft' && deleteAccess(data) && data.createdBy && data.createdBy === loggedInUserId"
                      mat-icon-button
                      (click)="deleteDialog(data)"
                      [attr.data-test-id]="'delete-button'"
                      i18n-matTooltip
                      [matTooltip]="'Delete ' + (data['type'] || data['taskType'] || '')"
                    >
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button>
                    <button
                      *ngIf="duplicateFlag && data['taskType'] && (data['taskType'] === 'Task' || data['taskType'] === 'Sub-Task') && (AccessTask(data) | can: 'duplicate')"
                      mat-icon-button
                      (click)="duplicateRecord($event, data)"
                      [attr.data-test-id]="'duplicate-button'"
                      i18n-matTooltip
                      [matTooltip]="'Duplicate ' + (data['type'] || data['taskType'] || '')"
                    >
                      <mat-icon class="material-icons-outlined">file_copy</mat-icon>
                    </button>
                  </td>
                </ng-container>
              </ng-container>
              <td *ngSwitchCase="tableColumnType.expand" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x">
                <button
                  *ngIf="((data?.subProjects && data?.subProjects.length > 0) || (data?.tasks && data?.tasks.length > 0) || (data?.childIds && data?.childIds.length > 0)) && !data?.expanded"
                  mat-icon-button
                  [attr.data-test-id]="'expand-button'"
                  (click)="expandRow($event, i)"
                >
                  <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
                </button>
                <button
                  *ngIf="((data?.subProjects && data?.subProjects.length > 0) || (data?.tasks && data?.tasks.length > 0) || (data?.childIds && data?.childIds.length > 0)) && data?.expanded"
                  mat-icon-button
                  [attr.data-test-id]="'collapse-button'"
                  (click)="collapseRow($event, i)"
                >
                  <mat-icon class="material-icons-outlined">expand_more</mat-icon>
                </button>
              </td>
              <td *ngSwitchCase="tableColumnType.date" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <span *ngIf="col.dateColor" [colorifyDate]="{ deadline: data.deadline, colname: col['columnDef'], milestone: data.nextDueDate }">{{ data[col['columnDef']] | spDateFormat }}</span>
                <span *ngIf="!col.dateColor">{{ data[col['columnDef']] | spDateFormat: { plainDate: true, isSafe: true } }}</span>
              </td>
              <td *ngSwitchCase="tableColumnType.dateTime" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <span *ngIf="col.dateColor" [colorifyDate]="{ deadline: data.deadline, colname: col['columnDef'], milestone: data.nextDueDate }">{{
                  data[col['columnDef']] | spDateFormat: { dateTimeShort: true }
                }}</span>
                <span *ngIf="!col.dateColor">{{ data[col['columnDef']] | spDateFormat: { dateTimeShort: true } }}</span>
              </td>
              <td *ngSwitchCase="tableColumnType.userIcon" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <div class="h-8 w-8 rounded-full mx-8">
                  <div class="relative">
                    <sp-avatar
                      [user]="
                        data.type && (data.type === 'Project' || data.type === 'Sub-Project')
                          ? data[col['columnDef']]
                          : data['currentlyWithUser'] && data['currentlyWithUser'].name
                            ? data['currentlyWithUser']
                            : data['currentlyWithTeam']
                      "
                      [size]="avatarSize"
                      [fontSize]="avatarFontSize"
                      [showToolTip]="showNameToolTip"
                    >
                    </sp-avatar>
                  </div>
                </div>
              </td>
              <td *ngSwitchCase="tableColumnType.array" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <ng-template [ngIf]="data[col.columnDef] && data[col.columnDef].length > 0">
                  <ng-template ngFor let-user [ngForOf]="data[col.columnDef]" let-uIndex="index">
                    <div class="h-8 w-8 rounded-full inline-block align-top" *ngIf="uIndex < 3" [ngClass]="{ 'mx-8': data[col.columnDef].length === 1 }">
                      <div class="relative" *ngIf="uIndex < 2">
                        <sp-avatar
                          [user]="user"
                          [annotationClass]="'annotationStatus_small'"
                          [blankImageSize]="'annotationStatus_size'"
                          [externalFlag]="true"
                          [size]="avatarSize"
                          [fontSize]="avatarFontSize"
                          [showToolTip]="showNameToolTip"
                        >
                        </sp-avatar>
                      </div>
                      <div class="relative" *ngIf="uIndex === 2">
                        <div class="relative" [matTooltip]="(showUsername$(data[col.columnDef] | slice: 2) | async) || ''">
                          <figure
                            [ngStyle]="{ width: avatarSize + 'px', height: avatarSize + 'px', 'background-color': '#C9C9C9' }"
                            class="sp-avatar-figure text-figure flex rounded-full justify-center items-center"
                          >
                            <span [ngStyle]="{ fontSize: avatarFontSize + 'px' }" class="font-medium"> + {{ data[col.columnDef].length - 2 }} </span>
                          </figure>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-template>
              </td>
              <td *ngSwitchCase="tableColumnType.createdByUserIcon" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <div class="h-8 w-8 rounded-full mx-8" [ngClass]="col['innerClass'] ? col['innerClass'] : ''">
                  <div class="relative">
                    <sp-avatar [user]="col['columnDef'] === 'createdBy' ? data['createdBy'] : data['owner']" [size]="avatarSize" [fontSize]="avatarFontSize" [showToolTip]="showNameToolTip">
                    </sp-avatar>
                  </div>
                </div>
              </td>
              <td *ngSwitchCase="tableColumnType.owners" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x">
                <div class="h-[100px] flex overflow-hidden p-1 gap-1">
                  <div class="flex flex-col items-center">
                    <div class="h-8 w-8 rounded-full mx-4" [ngClass]="col['innerClass'] ? col['innerClass'] : ''" *ngFor="let user of data[col.columnDef] | slice: 0 : 3">
                      <div class="relative">
                        <sp-avatar [user]="user" [size]="avatarSize" [fontSize]="avatarFontSize" [showToolTip]="showNameToolTip"> </sp-avatar>
                      </div>
                    </div>
                  </div>
                  <ng-template [ngIf]="data[col.columnDef] && data[col.columnDef].length > 3" class="flex items-end">
                    <div class="flex items-end">
                      <button (click)="ownersMenuTrigger.openMenu()">
                        <div class="rounded-full pl-2 pr-2 pb-1 pt-1 font-medium whitespace-nowrap" [ngStyle]="{ 'background-color': '#F7F6F6' }">+ {{ (data[col.columnDef] | slice: 3).length }}</div>
                        <div class="overlayMenu" matTooltip="Owners" #ownersMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="ownerListMenu"></div>
                      </button>
                      <mat-menu #ownerListMenu="matMenu" [overlapTrigger]="true">
                        <ng-template matMenuContent>
                          <ng-template ngFor let-user [ngForOf]="data[col.columnDef] | slice: 3">
                            <div class="flex flex-col items-center">
                              <div class="h-8 w-8 rounded-full mx-4" [ngClass]="col['innerClass'] ? col['innerClass'] : ''">
                                <div class="relative">
                                  <sp-avatar [user]="user" [size]="avatarSize" [fontSize]="avatarFontSize" [showToolTip]="showNameToolTip"> </sp-avatar>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </ng-template>
                      </mat-menu>
                    </div>
                  </ng-template>
                </div>
              </td>
              <td *ngSwitchCase="tableColumnType.indexing" [ngClass]="col['class'] ? col['class'] : ''" class="font-bold table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <span *ngIf="!data['objectType'] || (data['objectType'] !== 'subProjects' && data['objectType'] !== 'tasks' && data['objectType'] === 'subTasks')">{{ '#' + (i + 1) }}</span>
              </td>
              <td
                *ngSwitchCase="tableColumnType.name"
                (click)="detailsView(data, i, col['disableClick'])"
                [ngClass]="col['class'] ? col['class'] : ''"
                class="whitespace-nowrap table-cell-spacing-x grow flex items-center truncate"
              >
                <div class="inline-block" [ngClass]="data?.className">
                  <button
                    *ngIf="
                      ((data?.subProjects && data?.subProjects.length > 0) || (data?.tasks && data?.tasks.length > 0) || (data?.childIds && data?.childIds.length > 0)) &&
                      !data?.expanded &&
                      expandActionColumn
                    "
                    mat-icon-button
                    [attr.data-test-id]="'expand-button'"
                    (click)="expandRow($event, i)"
                  >
                    <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
                  </button>
                  <button
                    *ngIf="
                      ((data?.subProjects && data?.subProjects.length > 0) || (data?.tasks && data?.tasks.length > 0) || (data?.childIds && data?.childIds.length > 0)) &&
                      data?.expanded &&
                      expandActionColumn
                    "
                    mat-icon-button
                    [attr.data-test-id]="'collapse-button'"
                    (click)="collapseRow($event, i)"
                  >
                    <mat-icon class="material-icons-outlined">expand_more</mat-icon>
                  </button>
                </div>

                <div
                  class="inline-block"
                  *ngIf="(!data?.subProjects || data?.subProjects.length === 0) && (!data?.tasks || data?.tasks.length === 0) && (!data?.childIds || data?.childIds.length === 0) && expandActionColumn"
                >
                  <span class="pl-[20px] pr-[16px]"></span>
                </div>
                <div
                  class="inline-block align-middle truncate"
                  [ngClass]="data?.widthClassName ? data?.widthClassName : expandActionColumn ? 'w-[80%]' : 'w-[100%]'"
                  [matTooltip]="data[col['columnDef']]"
                  [attr.data-test-id]="tableName"
                >
                  <span class="flex items-center">
                    <span class="icon-wrapper">
                      <mat-icon class="material-icons-outlined text-xl mt-[2px]">
                        {{ data.type === 'Project' ? 'assignment_ind' : data.type === 'Sub-Project' ? 'assignment' : 'assignment_turned_in' }}
                      </mat-icon>
                    </span>
                    <span class="truncate">
                      {{
                        col['showValue'] && col['showValue'] && data[col['columnDef']] && data[col['columnDef']][col['showValue']] ? data[col['columnDef']][col['showValue']] : data[col['columnDef']]
                      }}
                    </span>
                  </span>
                </div>
              </td>
              <td *ngSwitchCase="tableColumnType.assetPreview" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <div class="h-[100px] w-full flex items-center overflow-hidden py-2 relative">
                  <a [routerLink]="data._id | assetLink" (click)="detailsView(data, i, false)" class="object-contain h-full w-full">
                    <img
                      *ngIf="data.imageUrl"
                      class="asset-list-image object-contain h-full m-auto w-full"
                      [src]="data.imageUrl | imageLoading | async"
                      [alt]="data.name"
                      [style.pointerEvents]="!(data.expiryDate | dateNotExpired) ? 'none' : 'all'"
                      [class.opacity-40]="isAssetPlannedOrUnpublished(data)"
                      [attr.asset-id]="data._id"
                    />
                    <div *ngIf="!data.previewUrl && (data?.expiryDate | dateNotExpired) && data?.assetType !== 'ZIP'" class="h-full w-full flex justify-center items-center">
                      <span class="font-bold" i18n>Preview Not Available</span>
                    </div>

                    <!-- Overlay for expired assets  -->
                    <sp-overlay class="asset-overlay-semitransparent top-0 left-0" *ngIf="!(data.expiryDate | dateNotExpired)">
                      <span class="font-bold" i18n>Expired</span>
                    </sp-overlay>

                    <div *ngIf="data.previewUrl && data.assetType === 'Powerpoint presentation'" class="font-bold h-full w-full flex justify-center items-center">
                      <mat-icon class="cursor-pointer mr-2 material-icons-outlined">description</mat-icon>&nbsp;<ng-container i18n>Click to preview</ng-container>
                    </div>
                    <div *ngIf="data.assetType === 'Audio'" class="font-bold h-full w-full flex justify-center items-center">
                      <mat-icon class="cursor-pointer mr-2 material-icons-outlined">audiotrack</mat-icon>
                    </div>
                    <div *ngIf="data.assetType === 'ZIP'" class="font-bold h-full w-full flex justify-center items-center">
                      <mat-icon class="cursor-pointer mr-2 material-icons-outlined">folder_zip</mat-icon>
                    </div>
                  </a>
                </div>
                <!-- Overlay for expired assets  -->
              </td>
              <td *ngSwitchCase="tableColumnType.collectionPreview" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <div class="h-[100px] w-full flex items-center overflow-hidden py-2 relative">
                  <a [routerLink]="data?._id" (click)="detailsView(data, i, false)" class="object-contain h-full w-full">
                    <img
                      *ngIf="data[col.columnDef]?.imageUrl"
                      class="object-contain h-full m-auto w-full"
                      [src]="data[col.columnDef].imageUrl | imageLoading | async"
                      [alt]="data.name"
                      [style.pointerEvents]="!(data?.expiryDate | dateNotExpired) ? 'none' : 'all'"
                    />
                    <div *ngIf="!data[col.columnDef]?.imageUrl" class="h-full w-full flex justify-center items-center">
                      <span class="font-bold" i18n>Preview Not Available</span>
                    </div>
                  </a>
                </div>
              </td>
              <td *ngSwitchCase="tableColumnType.tags" [ngClass]="col['class'] ? col['class'] : ''" class="tags-column table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <div class="h-[100px] flex overflow-hidden p-1 gap-1">
                  <div *ngIf="data[col.columnDef]">
                    <div *ngFor="let tag of data[col.columnDef] | slice: 0 : 3" class="tag w-min rounded-full pl-4 pr-4 pb-1 pt-1 mb-1 truncate max-w-[6rem]" style="background-color: #f7f6f6">
                      <span [matTooltip]="((tag | tagName | async) || '').length > 7 ? (tag | tagName | async) || '' : ''">
                        {{ tag | tagName | async }}
                      </span>
                    </div>
                  </div>
                  <div *ngIf="data[col.columnDef] && data[col.columnDef].length > 3" class="flex items-end">
                    <div
                      class="rounded-full pl-2 pr-2 pb-1 pt-1 font-medium whitespace-nowrap"
                      style="background-color: #f7f6f6"
                      [matTooltip]="(data[col.columnDef] | tagName: { slice: 3 } | async) || ''"
                    >
                      + {{ (data[col.columnDef] | slice: 3).length }}
                    </div>
                  </div>
                </div>
              </td>
              <ng-container *ngIf="!configObject || !configObject?.hideSelection">
                <td *ngSwitchCase="tableColumnType.checkbox" [ngClass]="col['class'] ? col['class'] : ''" class="sticky-checkbox-column flex items-center h-full">
                  <mat-checkbox
                    *ngIf="tableType !== 'assets' || configObject?.callFrom === 'collection' || configObject?.emitSelectedAssets; else addToBasket"
                    class="example-margin"
                    (change)="checkboxChanged.emit({ data: data, checked: $event.checked })"
                    [checked]="data?.checked"
                  >
                  </mat-checkbox>
                  <ng-template #addToBasket>
                    <mat-checkbox *ngIf="tableType === 'assets'" class="example-margin" (change)="checkboxChanged.emit(data)" [checked]="data?.isAddedToBasket"> </mat-checkbox>
                  </ng-template>
                </td>
              </ng-container>
              <td *ngSwitchCase="tableColumnType.hoursInNumber" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x" (click)="detailsView(data, i, col['disableClick'])">
                <span> {{ data[col.columnDef] ? data[col.columnDef] : '' }} </span>
              </td>
              <td *ngSwitchCase="tableColumnType.assetCount" [ngClass]="col['class'] ? col['class'] : ''" class="table-cell-spacing-x">
                <span> {{ data[col.columnDef] ? data[col.columnDef].length : '' }} </span>
              </td>
              <td
                *ngSwitchDefault
                [ngClass]="rowHeightAuto ? (col['class'] ? col['class'] : '') : col['class'] ? col['class'] + ' truncate' : ' truncate'"
                class="table-cell-spacing-x"
                (click)="detailsView(data, i, col['disableClick'])"
              >
                <button
                  *ngIf="col.link"
                  (click)="navigateLink($event, col.link, data[col.columnDef])"
                  class="link-table-inline"
                  [matTooltip]="
                    col.showValue && data[col.columnDef] && data[col.columnDef][col.showValue]?.length > 15
                      ? data[col.columnDef][col.showValue]
                      : data[col.columnDef]?.length > 15
                        ? data[col.columnDef]
                        : null
                  "
                >
                  {{
                    col['showValue'] && data[col['columnDef']]
                      ? data[col['columnDef']][col['showValue']]
                        ? data[col['columnDef']][col['showValue']]
                        : ''
                      : data[col['columnDef']]
                        ? data[col['columnDef']]
                        : ''
                  }}
                </button>
                <span
                  [ngClass]="col['innerClass'] ? col['innerClass'] : ''"
                  *ngIf="!col.link"
                  [matTooltip]="
                    col.showValue &&
                    data[col.columnDef] &&
                    data[col.columnDef][col.showValue] &&
                    ((isArray(data[col['columnDef']][col['showValue']]) && data[col['columnDef']][col['showValue']].toString().length > 12) || data[col.columnDef][col.showValue]?.length > 15)
                      ? data[col.columnDef][col.showValue]
                      : (isArray(data[col.columnDef]) && data[col.columnDef].toString().length > 12) || data[col.columnDef]?.length > 15
                        ? data[col.columnDef]
                        : null
                  "
                >
                  {{
                    col['showValue'] && data[col['columnDef']]
                      ? data[col['columnDef']][col['showValue']]
                        ? !isObject(data[col['columnDef']][col['showValue']])
                          ? (data[col['columnDef']][col['showValue']] | optionsLabel: col['options'])
                          : fetchData(data[col['columnDef']][col['showValue']], col['options'])
                        : ''
                      : (data[col['columnDef']] | optionsLabel: col['options'])
                        ? (data[col['columnDef']] | optionsLabel: col['options'])
                        : ''
                  }}
                </span>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </cdk-virtual-scroll-viewport>
    </tbody>
  </table>
</div>
